import form from '@/mixins/crud-form';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'MARKET_APP_INFO_DETAIL',
        create: 'MARKET_APP_INFO_CREATE',
        update: 'MARKET_APP_INFO_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'market_id',
        default: '',
        label: 'market_id',
        col: {
          span: 16
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "form_market_id",
              "custom": true,
              "stringify": true
            },
            "model": {
              value: _this.form.model.market_id,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "market_id", $$v);
              }
            }
          });
        }
      }, {
        prop: 'app_name',
        default: '',
        label: 'app_name',
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.app_name,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "app_name", $$v);
              }
            }
          });
        }
      }, {
        prop: 'app_type',
        default: '',
        label: 'app_type',
        col: {
          span: 16
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "app_type",
              "button": true
            },
            "model": {
              value: _this.form.model.app_type,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "app_type", $$v);
              }
            }
          });
        }
      }, {
        prop: 'app_uType',
        default: '',
        label: 'app_uType',
        col: {
          span: 16
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "app_uType",
              "button": true
            },
            "model": {
              value: _this.form.model.app_uType,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "app_uType", $$v);
              }
            }
          });
        }
      }, {
        prop: 'app_status',
        default: '',
        label: 'app_status',
        col: {
          span: 16
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "app_status",
              "button": true
            },
            "model": {
              value: _this.form.model.app_status,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "app_status", $$v);
              }
            }
          });
        }
      }, {
        prop: 'app_config_xml',
        default: '',
        label: 'app_config_xml',
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "type": "textarea",
              "autosize": true,
              "clearable": true
            },
            "model": {
              value: _this.form.model.app_config_xml,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "app_config_xml", $$v);
              }
            }
          });
        }
      }, {
        prop: 'app_kf_mobile',
        default: '',
        label: 'app_kf_mobile',
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.app_kf_mobile,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "app_kf_mobile", $$v);
              }
            }
          });
        }
      }];
    }
  },
  methods: {
    /**
         * @description 加载需要的字典数据
         */
    loadDict: function loadDict() {
      // 衣物类型
      this.loadDictOne({
        name: 'form_market_id',
        method: this.$api.MARKET_ALL,
        fields: 'id,market_mobile',
        path: 'list',
        label: 'market_mobile',
        value: 'id'
      });
    }
  }
};